import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { MinWidthProps } from 'styled-system';
import { minWidth, space } from 'styled-system';

import BaseIcon from 'common/components/Icon';
import type { SpaceProps } from 'common/theme/system-types';

const ICON_SIZE = 32;

const UnstyledIcon = styled(BaseIcon)<SpaceProps & MinWidthProps>`
  ${minWidth};
  ${space};
`;

const Icon = (props: ComponentProps<typeof UnstyledIcon>) => (
  <UnstyledIcon minWidth={ICON_SIZE} {...props} />
);

export default Icon;
